import React from 'react';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { InspectionChecklist } from '../common';

export const CartonCheckList: React.FC<DynamicComponentProps> = (props: DynamicComponentProps) => {
  return (
    <InspectionChecklist
      {...props}
      defaultHeader="Carton Check Details"
      completionTranslationKey="carton_check_checkpoint_complete"
    />
  );
};
